<template lang="pug">
  .v-container
    .u-fs-xl.u-weight-bold WARNING!
    hr.c-hr
    .u-flex.u-flex-jc-space_between.u-flex-ai-center.u-mbm
      p This payment method is already linked to another account. Please know any orders paid for by this payment method will not include first-time purchaser benefits of any kind in relation to TOM services.

    .v-btn-wrapper.u-align-right.u-align-center--sm
      button.c-btn.c-btn--primary.c-btn--lg.c-btn--link.u-mbs(type="button", @click="onClose") Cancel
      button.c-btn.c-btn--primary.c-btn--lg.u-mbs(type="button", @click="onSubmit") Place Your Order

</template>
<script>
  export default {
    props: {
      checkoutPremium: Function
    },
    methods: {
      onSubmit() {
        tom.helper.ga.push ['event', 'EC', 'Clicked', 'AgreePremiumAlreadyLinkedWaring', 1];
        this.checkoutPremium();
        this.$emit('close');
      },
      onClose() {
        tom.helper.ga.push ['event', 'EC', 'Clicked', 'ClosePremiumAlreadyLinkedWaring', 1];
        this.$emit('close');
      }
    }
  };
</script>

<style scoped>
  .v-container {
    padding: 20px;
  }

  @media (max-width: 767px) {
    .v-btn-wrapper {
      display: flex;
      flex-direction: column-reverse;
    }
  }

</style>
